import { useContext, useState } from "react";
import { AppContext } from "../../Context";
import { FilterButton } from "../hooks/filtres/useTableFilters";

const UserList = () => {
  const {
    users,
    userLength,
    editMode,
    cancelEdit,
    updateUser,
    deleteUser,
    filterdto,
  } = useContext(AppContext);

  // Storing users new data when they editing their info.
  const [newData, setNewData] = useState({});

  const saveBtn = () => {
    updateUser(newData);
  };

  const updateNewData = (e, field) => {
    setNewData({
      ...newData,
      [field]: e.target.value,
    });
  };

  const enableEdit = (idusuario, nome, login) => {
    setNewData({ idusuario, nome, login });
    editMode(idusuario);
  };

  const deleteConfirm = (idusuario) => {
    if (window.confirm("Confirma a exclusão?")) {
      deleteUser(idusuario);
    }
  };

  return !userLength ? (
    <p>{userLength === null ? "Carregando..." : "Favor, insira uma usuário"}</p>
  ) : (
    <>
    <FilterButton/>
    <table>
      <thead>
        <tr>
          <th>Usuário</th>
          <th>Telefone</th>
          <th>Ação</th>
        </tr>
      </thead>
      <tbody>
        {users.filter((data) => {
          return filterdto === undefined || (String)(data.nome).toLowerCase().includes((String)(filterdto.toLowerCase())) || data.login.includes(filterdto) ? data : null
        })
        .map(({ idusuario, nome, login, isEditing }) => {
          return isEditing === true ? (
            <tr key={idusuario}>
              <td>
                <input
                  type="text"
                  defaultValue={nome}
                  onChange={(e) => updateNewData(e, "nome")}
                />
              </td>
              <td>
                <input
                  type="number"
                  defaultValue={login}
                  onChange={(e) => updateNewData(e, "login")}
                />
              </td>
              <td>
                <a className="waves-effect waves-light btn green-btn" onClick={() => saveBtn()}>
                <i class="material-icons left">save</i>
                </a>
                <a
                  className="waves-effect waves-light btn default-btn"
                  onClick={() => cancelEdit(idusuario)}
                >
                <i class="material-icons left">cancel</i>
                </a>
              </td>
            </tr>
          ) : (
            <tr key={idusuario}>
              <td>{nome}</td>
              <td>{login}</td>
              <td>
                <a
                  className="waves-effect waves-light btn default-btn"
                  onClick={() => enableEdit(idusuario, nome, login)}
                >
                <i class="material-icons left">edit</i>
                </a>
                <a
                  className="waves-effect waves-light btn red-btn"
                  onClick={() => deleteConfirm(idusuario)}
                >
                <i class="material-icons left">delete</i>
                </a>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
    </>);
};

export default UserList;